import React from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useAuth, ROLES, MODULES } from "./context/AuthContext";
import Login from "./view/Admin/Login";
import ViewAdmin from "./view/Admin/View";
import ContactUs from "./view/ContactUs/ContactUs";
import ViewContact from "./view/ContactUs/View";
import ContentManagement from "./view/ContentManagement/ContentManagement";
import UpdateContent from "./view/ContentManagement/UpdateContent";
import Dashboard from "./view/Admin/Dashboard";
import AddFaq from "./view/Faq/AddFaq";
import Faq from "./view/Faq/Faq";
import UpdateFaq from "./view/Faq/UpdateFaq";
import AddInquiry from "./view/Inquiry/AddInquiry";
import CreateAccount from "./view/Inquiry/CreateAccount";
import Inquiry from "./view/Inquiry/Inquiry";
import ViewInquiry from "./view/Inquiry/ViewInquiry";
import Merchant from "./view/MerchantModule/Merchant";
import UpdateMerchant from "./view/MerchantModule/UpdateMerchant";
import ViewMerchant from "./view/MerchantModule/ViewMerchant";
import ViewApp from "./view/MerchantAppsModules/ViewApp";
import NotificationManagement from "./view/NotificationManagement";
import WalletUser from "./view/UserModule/WalletUser";
import WalletUserEdit from "./view/UserModule/WalletUserEdit";
import WalletUserView from "./view/UserModule/WalletUserView";
import AdminLayout from "./view/shared/AdminLayout";
import UnAuthLayout from "./view/shared/UnAuthLayout";
import UnauthenticatedRoute from "./view/shared/UnauthenticatedRoute";
import PrivateRoute from "./view/shared/PrivateRoute";
import UpdateOtherCmsPages from "./view/ContentManagement/UpdateOtherCmsPages";
import ChangePassword from "./view/Admin/ChangePassword";
import ResetPassword from "./view/Admin/ResetPassword";
import ForgotPassword from "./view/Admin/ForgotPassword";
import UpdatePricingPage from "./view/ContentManagement/UpdatePricingPage";
import UpdateHowItWorks from "./view/ContentManagement/UpdateHowItWorks";
import UpdateTestimonial from "./view/ContentManagement/UpdateTestimonial";
import FeeManagement from "./view/PaymentManagement/FeeManagement";
import CustmerSupport from "./view/CustomerSupport/CustomerSupport";
import UpdateCustomerSupport from "./view/CustomerSupport/UpdateCustomerSupport";
import UpdateContactUs from "./view/ContactUs/UpdateContactUs";
import TransactionManagement from "./view/TransactionManagement/TransactionManagement";
import WithdrawalLimit from "./view/PaymentManagement/WithdrawalLimit";
import PaymentManagement from "./view/PaymentManagement/PaymentManagement";
import ViewPaymentLink from "./view/PaymentManagement/ViewPaymentLink";
import AddToken from "./view/PaymentManagement/AddToken";
import SystemSettings from "./view/PaymentManagement/SystemSettings";
import FiatTransaction from "./view/TransactionManagement/FiatTransaction";
import ViewFiatTransaction from "./view/TransactionManagement/ViewFiatTransaction";
import AdminList from "./view/AdminManagement/AdminList";
import CreateAdmin from "./view/AdminManagement/CreateAdmin";
import UpdateAdminRole from "./view/AdminManagement/UpdateAdminRole";
import UserWithdrawalsAdmin from "./view/UserWithdrawalsAdmin/UserWithdrawalsAdmin";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      //admin route
      {
        path: "/",
        element: <Navigate to={"/dashboard"} />,
      },
      {
        path: "/dashboard",
        element: <PrivateRoute component={<Dashboard />} requiredPermission="dashboard" />,
      },
      {
        path: "/admin-view",
        element: <PrivateRoute component={<ViewAdmin />} />,
      },
      {
        path: "/admin-change-password",
        element: <PrivateRoute component={<ChangePassword />} />,
      },

      // Admin Management (Super Admin Only)
      {
        path: "/admin-management",
        element: <PrivateRoute component={<AdminList />} requiredRole="super_admin" />,
      },
      {
        path: "/admin-management/create",
        element: <PrivateRoute component={<CreateAdmin />} requiredRole="super_admin" />,
      },
      {
        path: "/admin-management/update-role/:adminId",
        element: <PrivateRoute component={<UpdateAdminRole />} requiredRole="super_admin" />,
      },

      //users route
      {
        path: "/users",
        element: <PrivateRoute component={<WalletUser />} requiredPermission="wallet_management" />,
      },
      {
        path: "/users-view/:userId",
        element: <PrivateRoute component={<WalletUserView />} requiredPermission="wallet_management" />,
      },
      {
        path: "/users-edit/:userId",
        element: <PrivateRoute component={<WalletUserEdit />} requiredPermission="wallet_management" />,
      },

      //merchant route
      {
        path: "/merchants",
        element: <PrivateRoute component={<Merchant />} requiredPermission="merchant_management" />,
      },
      {
        path: "/merchants-view/:userId",
        element: <PrivateRoute component={<ViewMerchant />} requiredPermission="merchant_management" />,
      },
      {
        path: "/merchants-apps-view/:userId",
        element: <PrivateRoute component={<ViewApp />} requiredPermission="merchant_management" />,
      },
      {
        path: "/view-payment-link/:paymentId",
        element: <PrivateRoute component={<ViewPaymentLink />} requiredPermission="merchant_management" />,
      },
      {
        path: "/merchants-edit/:userId",
        element: <PrivateRoute component={<UpdateMerchant />} requiredPermission="merchant_management" />,
      },
      {
        path: "/view-payment-link/:paymentId",
        element: <PrivateRoute component={<ViewPaymentLink />} requiredPermission="merchant_management" />,
      },

      // inquiry route
      {
        path: "/inquiry",
        element: <PrivateRoute component={<Inquiry />} requiredPermission="inquiry_management" />,
      },
      {
        path: "/inquiry-view/:userId",
        element: <PrivateRoute component={<ViewInquiry />} requiredPermission="inquiry_management" />,
      },
      {
        path: "/inquiry-create-account/:userId",
        element: <PrivateRoute component={<CreateAccount />} requiredPermission="inquiry_management" />,
      },
      {
        path: "/inquiry-add",
        element: <PrivateRoute component={<AddInquiry />} requiredPermission="inquiry_management" />,
      },

      //cms route
      {
        path: "/content-management",
        element: <PrivateRoute component={<ContentManagement />} requiredPermission="content_management" />,
      },
      {
        path: "/content-management-update/:pageId",
        element: <PrivateRoute component={<UpdateContent />} requiredPermission="content_management" />,
      },

      {
        path: "/content-management-update-other/:pageId",
        element: <PrivateRoute component={<UpdateOtherCmsPages />} requiredPermission="content_management" />,
      },

      {
        path: "/content-management-pricing-page/:pageId",
        element: <PrivateRoute component={<UpdatePricingPage />} requiredPermission="content_management" />,
      },

      {
        path: "/content-management-how-it-works/:pageId",
        element: <PrivateRoute component={<UpdateHowItWorks />} requiredPermission="content_management" />,
      },

      {
        path: "/content-management-testimonial/:pageId",
        element: <PrivateRoute component={<UpdateTestimonial />} requiredPermission="content_management" />,
      },

      // /faq route
      {
        path: "/faq",
        element: <PrivateRoute component={<Faq />} requiredPermission="faq_management" />,
      },
      {
        path: "/faq-add",
        element: <PrivateRoute component={<AddFaq />} requiredPermission="faq_management" />,
      },
      {
        path: "/faq-update/:faqId",
        element: <PrivateRoute component={<UpdateFaq />} requiredPermission="faq_management" />,
      },

      // Contact us route
      {
        path: "/contact-us",
        element: <PrivateRoute component={<ContactUs />} requiredPermission="contact_us" />,
      },
      {
        path: "/contact-us-view/:userId",
        element: <PrivateRoute component={<ViewContact />} requiredPermission="contact_us" />,
      },

      {
        path: "/contact-us-update/:userId",
        element: <PrivateRoute component={<UpdateContactUs />} requiredPermission="contact_us" />,
      },

      // transaction management
      {
        path: "/transaction",
        element: <PrivateRoute component={<TransactionManagement />} requiredPermission="transaction_monitoring" />,
      },

      // fiat transaction

      {
        path: "/fiat-transaction",
        element: <PrivateRoute component={<FiatTransaction />} requiredPermission="fiat_transactions" />,
      },

      {
        path: "/fiat-transaction-view/:fiatWithdrawId",
        element: <PrivateRoute component={<ViewFiatTransaction />} requiredPermission="fiat_transactions" />,
      },


      // payment management
      {
        path: "/payment-management",
        element: <PrivateRoute component={<PaymentManagement />} requiredPermission="payment_management" />,
      },
      {
        path: "/system-settings",
        element: <PrivateRoute component={<SystemSettings />} requiredPermission="payment_management" />,
      },
      {
        path: "/fee-management",
        element: <PrivateRoute component={<FeeManagement />} requiredPermission="payment_management" />,
      },

      //extension customer support
      {
        path: "/customer-support",
        element: <PrivateRoute component={<CustmerSupport />} requiredPermission="customer_support" />,
      },
      {
        path: "/customer-support-view/:userId",
        element: <PrivateRoute component={<UpdateCustomerSupport />} requiredPermission="customer_support" />,
      },

      {
        path: "/withdrawal-limit",
        element: <PrivateRoute component={<WithdrawalLimit />} requiredPermission="payment_management" />,
      },

      {
        path: "/withdrawal-limit-add-token",
        element: <PrivateRoute component={<AddToken />} requiredPermission="payment_management" />,
      },

      {
        path: "/notification-management",
        element: <PrivateRoute component={<NotificationManagement />} requiredPermission="notification" />,
      },

      // User Withdrawals Management
      {
        path: "/user-withdrawals",
        element: <PrivateRoute component={<UserWithdrawalsAdmin />} requiredPermission="user_withdrawals" />,
      },

      {
        path: "/logout",
        element: <PrivateRoute component={<Login />} />,
      },

      //APPS
      {
        path: "/logout",
        element: <PrivateRoute component={<Login />} />,
      },
    ],
  },
  {
    path: "/",
    element: <UnAuthLayout />,
    children: [
      {
        path: "/login",
        element: <UnauthenticatedRoute component={Login} />,
      },
      {
        path: "/reset-password",
        element: <UnauthenticatedRoute component={ResetPassword} />,
      },
      {
        path: "/forget-password",
        element: <UnauthenticatedRoute component={ForgotPassword} />,
      },
    ],
  },
]);

export default routes;
